define( [
	"../../var/pnum"
], function( pnum ) {
	"use strict";

	return new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/css/var/rnumnonpx.js
 ** module id = 186
 ** module chunks = 0
 **/